<script lang="ts" module>
  import { TeoCore } from '@/teoCore/TeoCore';
  import type { IconName } from '@/ui/base/icon';
  import { useDynamicConfig } from '@/ui/state/use-core-state.svelte';

  import PageLink from '../assistant/Performance/DoneCard/cmps/PageLink.svelte';
  import { downloadReport } from '../report/use-report.svelte';

  const actionOptions = {
    newText: {
      label: 'Neuen Text analysieren',
      icon: 'NoteAdd',
      action: () => TeoCore.instance.addText(),
    },
    brandScanner: {
      label: 'Brand-Scanner öffnen',
      icon: 'Brand',
      action: () => {
        TeoCore.instance.activeText?.ui.update('view', 'brand-scanner');
      },
    },
    spellCheck: {
      label: 'Rechtschreibung prüfen',
      icon: 'Spellcheck',
      action: () => {
        TeoCore.instance.activeText?.ui.update('view', 'spellcheck');
      },
    },
    performanceReport: {
      label: 'Performance Report öffnen',
      icon: 'Report',
      action: () => downloadReport(TeoCore.instance),
    },
  };
</script>

<script lang="ts">
  const { actions }: { actions: Array<keyof typeof actionOptions> } = $props();
  const dynamicConfig = useDynamicConfig();
</script>

{#each actions as action, i (action)}
  {#if action !== 'brandScanner' || $dynamicConfig.brandFitEnabled}
    <PageLink
      pageLinkLabel={actionOptions[action]?.label}
      icon={actionOptions[action]?.icon as IconName}
      onClick={actionOptions[action]?.action}
    />
    {#if i < actions.length - 1}
      <hr class="border-t-c-divider" />
    {/if}
  {/if}
{/each}
